<!-- Card Name-->
<form [formGroup]="form">
    <mat-form-field appearance="outline"  >
        <mat-label>{{ label | translate }}</mat-label>
        <mat-select disableOptionCentering="true" formControlName="brandId" (selectionChange)="onClick()">
            <mat-option value="" selected> {{'Common.All'|translate}} </mat-option>
            <mat-option class="theme-select" *ngFor="let item of brandList" [value]="item.Id">
                [{{ item.NameAr }}] - {{ item.NameEn }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('brandId')?.errors?.['required']">
            {{ 'Common.RequiredField' | translate }}
        </mat-error>
    </mat-form-field>
</form>